import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgMatModule } from './modules/ngmat.module';

import { LayoutModule } from 'src/app/_layout/layout.module';
import { ChecklistComponent } from './components/checklist/checklist.component';
import { CheckItemComponent } from './components/check-item/check-item.component';
import { AppFocusDirective } from './directives/app-focus.directive';
import { AppFocusNextDirective } from './directives/app-focus-next.directive';
import { ProgressRingComponent } from './components/progress-ring/progress-ring.component';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { DialogComponent } from './components/dialog/dialog.component';
import { AlertBarComponent } from './components/alert-bar/alert-bar.component';
import { EmailPinPageComponent } from './components/email-pin-page/email-pin-page.component';
import { I18nModule } from './i18n/i18n.module';
import { PrivacyStatementLinkComponent } from './components/privacy-statement-link/privacy-statement-link.component';
import { RouterModule } from '@angular/router';
import { IconMessageComponent } from '@shared/components/error-message/icon-message.component';
import { SelectDialogComponent } from '@shared/components/select-dialog/select-dialog.component';
import { MenuListItemExpanderComponent } from '@shared/components/menu-list/menu-list-item-expander/menu-list-item-expander.component';
import { MenuListItemNavComponent } from '@shared/components/menu-list/menu-list-item-nav/menu-list-item-nav.component';
import { FileSizePipe } from '@shared/utils/file-size.pipe';
import { PhonePinPageComponent } from './components/phone-pin-page/phone-pin-page.component';
import { UserPhoneDialogComponent } from '@shared/components/user-details-dialog';
import { BrowserProblemLinkComponent } from './components/browser-problem-link/browser-problem-link.component';
import { CopyButtonComponent } from './components/copy-button/copy-button.component';
import { NotFoundPageComponent } from './components/not-found-page/not-found-page.component';
import { SkipInteractionCheckboxComponent } from './components/skip-interaction-checkbox/skip-interaction-checkbox.component';
import { DomModule } from '@shared/dom';
import { NomidioFormsModule } from '@shared/forms';
import { NomidioPhoneModule  } from '@shared/phone';
import { NomidioQrcodeModule } from '@shared/qrcode';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { MenuListItemDownloadComponent } from './components/menu-list';
import { AvatarComponent } from './components/avatar/avatar.component';
import { MatIconModule } from '@angular/material/icon';
import { TotpCodeComponent } from './components/totp-code/totp-code.component';
import { ImageCropperComponent } from './components/image-cropper/image-cropper/image-cropper.component';
import { ImageCropperDialogComponent } from './components/image-cropper';
import { LanguageSwitcherDialogComponent } from './components/language-switcher-dialog/language-switcher-dialog.component';

const share = [
  ChecklistComponent,
  CheckItemComponent,
  AppFocusDirective,
  AppFocusNextDirective,
  ErrorPageComponent,
  IconMessageComponent,
  ProgressRingComponent,
  DialogComponent,
  SelectDialogComponent,
  UserPhoneDialogComponent,
  AlertBarComponent,
  PhonePinPageComponent,
  EmailPinPageComponent,
  PrivacyStatementLinkComponent,
  MenuListItemExpanderComponent,
  MenuListItemNavComponent,
  MenuListItemDownloadComponent,
  FileSizePipe,
  BrowserProblemLinkComponent,
  CopyButtonComponent,
  NotFoundPageComponent,
  SkipInteractionCheckboxComponent,
  SpinnerComponent,
  AvatarComponent,
  TotpCodeComponent,
  ImageCropperComponent,
  ImageCropperDialogComponent,
  LanguageSwitcherDialogComponent,
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NomidioFormsModule,
    NomidioPhoneModule,
    NomidioQrcodeModule,
    NgMatModule,
    MatIconModule,
    LayoutModule,
    I18nModule,
    RouterModule,
    DomModule,
  ],
  declarations: share,
  exports: share,
})
export class SharedModule { }
